var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.25 1.962L15.538.25 8.75 7.038 1.962.25.25 1.962 7.038 8.75.25 15.538l1.712 1.712 6.788-6.788 6.788 6.788 1.712-1.712-6.788-6.788z","fill":"#044567","fillRule":"evenodd"}));
}

Cross.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = Cross;

Cross.default = Cross;
